import {
  Shield, Car, Users, Calendar, DollarSign,
  LogOut, FileText, User, X, TrendingUp,
  UserCog, Briefcase, Mail, CreditCard, Image, UserPlus, Contact, Eye, Coins, BarChart3,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MobileMenuLogo } from "./LogoVariants";
import { useAuth } from "../../context/AuthContext";

var ADMIN_EMAIL = "admin@methoscorretora.com.br";
var ROLE_LABELS = { admin: "Gestor", team_leader: "Lider de Equipe", broker: "Corretor", assistant: "Assistente" };

function getInitials(name) {
  if (!name) return "U";
  var parts = name.split(" ");
  return ((parts[0] ? parts[0][0] : "") + (parts[1] ? parts[1][0] : "")).toUpperCase();
}
function mobCls(active) {
  if (active) return "flex items-center gap-2.5 px-3 py-1.5 rounded-lg bg-[#3B82F6] text-white";
  return "flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-white/60";
}
function MobCat({ label }) {
  return (
    <div className="pt-2.5 mt-1 border-t border-white/10 first:pt-0 first:mt-0 first:border-t-0">
      <p className="px-3 text-white/40 text-[9px] font-semibold uppercase tracking-wider mb-0.5">{label}</p>
    </div>
  );
}
function hasPerm(user, mod) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.role === "assistant") { var mp = (user.permissions || {})[mod] || {}; return !!mp.view; }
  return true;
}

export function MobileMenuPanel({ isOpen, onClose, viewMode, onViewChange, user, isAdmin, activePage }) {
  var navigate = useNavigate();
  var auth = useAuth();
  if (!isOpen) return null;
  var initials = getInitials(user ? user.name : null);
  var isTeamLeader = user ? user.role === "team_leader" : false;
  var isAssistant = user ? user.role === "assistant" : false;
  var isSuperAdmin = user ? user.email === ADMIN_EMAIL : false;
  var showGestao = isAdmin || isTeamLeader;

  function go(path) { navigate(path); onClose(); }

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className="fixed left-0 top-0 bottom-0 w-72 bg-[#0A2F3D] p-4 overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <MobileMenuLogo />
          <button onClick={onClose} className="p-2 text-white/60 hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        {(isAdmin || isAssistant) && (
          <div className="mb-4">
            <div className="bg-white/5 rounded-xl p-1 flex gap-1">
              <button onClick={function() { onViewChange("gestor"); }}
                className={"flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium " + (viewMode === "gestor" ? "bg-[#3B82F6] text-white" : "text-white/50")}>
                <Briefcase className="w-3.5 h-3.5" />{isAssistant ? "Assistente" : "Gestor"}
              </button>
              <button onClick={function() { onViewChange("corretor"); }}
                className={"flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium " + (viewMode === "corretor" ? "bg-[#F26A4B] text-white" : "text-white/50")}>
                <User className="w-3.5 h-3.5" />Corretor
              </button>
            </div>
          </div>
        )}
        <div className="p-2.5 mb-3 bg-white/5 rounded-lg">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-[#3B82F6] flex items-center justify-center">
              <span className="text-white font-semibold text-xs">{initials}</span>
            </div>
            <div>
              <p className="text-white font-medium text-xs">{user ? user.name : ""}</p>
              <p className="text-white/50 text-[10px]">{ROLE_LABELS[user ? user.role : "broker"] || "Corretor"}</p>
            </div>
          </div>
        </div>
        <nav className="space-y-0.5">
          <MobCat label="Principal" />
          <div className={mobCls(activePage === "dashboard")} onClick={function() { go("/painel"); }}>
            <BarChart3 className="w-4 h-4" /><span className="font-medium text-sm">Dashboard</span>
          </div>
          <MobCat label="Comercial" />
          {hasPerm(user, "leads") && <div className={mobCls(activePage === "leads")} onClick={function() { go("/leads"); }}><Users className="w-4 h-4" /><span className="font-medium text-sm">Leads</span></div>}
          {hasPerm(user, "leads") && <div className={mobCls(activePage === "funil-leads")} onClick={function() { go("/funil-leads"); }}><TrendingUp className="w-4 h-4" /><span className="font-medium text-sm">Funil de Vendas</span></div>}
          {hasPerm(user, "clientes") && <div className={mobCls(activePage === "clientes")} onClick={function() { go("/clientes"); }}><Contact className="w-4 h-4" /><span className="font-medium text-sm">Clientes</span></div>}
          <MobCat label="Produtos" />
          {hasPerm(user, "consorcios") && <div className={mobCls(activePage === "consorcios")} onClick={function() { go("/consorcios"); }}><Car className="w-4 h-4" /><span className="font-medium text-sm">Consórcios</span></div>}
          {hasPerm(user, "seguros") && <div className={mobCls(activePage === "seguros")} onClick={function() { go("/seguros"); }}><Shield className="w-4 h-4" /><span className="font-medium text-sm">Seguros</span></div>}
          <MobCat label="Financeiro" />
          {hasPerm(user, "comissoes") && <div className={mobCls(activePage === "comissoes")} onClick={function() { go("/comissoes"); }}><DollarSign className="w-4 h-4" /><span className="font-medium text-sm">Comissoes</span></div>}
          {hasPerm(user, "pagamentos") && <div className={mobCls(activePage === "pagamentos")} onClick={function() { go("/pagamentos"); }}><CreditCard className="w-4 h-4" /><span className="font-medium text-sm">Pagamentos</span></div>}
          {(isAdmin || isAssistant) && (hasPerm(user, "comunicacao") || hasPerm(user, "banners")) && (
            <div>
              <MobCat label="Marketing" />
              {hasPerm(user, "comunicacao") && <div className={mobCls(activePage === "comunicacao")} onClick={function() { go("/comunicacao"); }}><Mail className="w-4 h-4" /><span className="font-medium text-sm">Comunicacao</span></div>}
              {hasPerm(user, "banners") && <div className={mobCls(activePage === "banners")} onClick={function() { go("/banners"); }}><Image className="w-4 h-4" /><span className="font-medium text-sm">Banners</span></div>}
            </div>
          )}
          {hasPerm(user, "indicacoes") && (showGestao || isAssistant) && <div className={mobCls(activePage === "indicacoes")} onClick={function() { go("/indicacoes"); }}><UserPlus className="w-4 h-4" /><span className="font-medium text-sm">Indicacoes</span></div>}
          <MobCat label="Gestao" />
          {hasPerm(user, "equipe") && (showGestao || isAssistant) && <div className={mobCls(activePage === "equipe")} onClick={function() { go("/equipe"); }}><UserCog className="w-4 h-4" /><span className="font-medium text-sm">Equipe</span></div>}
          {hasPerm(user, "relatorios") && (showGestao || isAssistant) && <div className={mobCls(activePage === "relatorios")} onClick={function() { go("/relatorios"); }}><FileText className="w-4 h-4" /><span className="font-medium text-sm">Relatorios</span></div>}
          {hasPerm(user, "agenda") && <div className={mobCls(activePage === "agenda")} onClick={function() { go("/agenda"); }}><Calendar className="w-4 h-4" /><span className="font-medium text-sm">Agenda</span></div>}
          {isAdmin && <div className={mobCls(activePage === "doletas")} onClick={function() { go("/doletas"); }}><Coins className="w-4 h-4" /><span className="font-medium text-sm">DOLETAS</span></div>}
          {isSuperAdmin && (
            <div>
              <MobCat label="Sistema" />
              <div className={mobCls(activePage === "vigia")} onClick={function() { go("/vigia"); }}><Eye className="w-4 h-4" /><span className="font-medium text-sm">VIGIA</span></div>
            </div>
          )}
        </nav>
        <div className="mt-3 pt-3 border-t border-white/10">
          <button onClick={function() { auth.logout(); }} className="w-full flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-white/60 hover:bg-red-500/10 hover:text-red-400 transition-colors" data-testid="mobile-logout-button">
            <LogOut className="w-4 h-4" /><span className="font-medium text-sm">Sair</span>
          </button>
        </div>
      </div>
    </div>
  );
}
